const CryptoJS = require('crypto-js')
var key = 'd6efc78c997c8b595a7a3dd5dc3c1f6a'
key = CryptoJS.enc.Utf8.parse(key)

export default {
  encrypt (str) {
    var enc = CryptoJS.AES.encrypt(str, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    var enced = enc.toString()
    return enced
  },
  decrypt (enced) {
    var dec = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(enced), key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(dec)
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/secret.js